<h2 rds-dialog-header>Event preview</h2>
<div rds-dialog-icon-placeholder>
  <button rds-icon-button size="m" [rds-dialog-close]="null">
    <rds-icon icon="close" namespace="outlined"></rds-icon>
  </button>
</div>

<div rds-dialog-content>
  <div class="event-preview__heading">
    <rds-tabs #tabs size="m">
      <rds-tab label="Event Abstract">
        <div *ngIf="userTimeZone !== event.timeZone" class="my-6">
          <rds-alert>
            <p>
              Date & Time on Event preview always reflects original event time zone (<b>{{event.timeZone}}</b>)
            </p>
            <p>
              Date & Time of Event in your local time zone (<b>{{userTimeZone}}</b>) is: <b>{{zonedDate | date:'MMMM d, y'}} {{event.allDay ? 'All day' : (zonedStart | date:'shortTime') + ' - ' + (zonedEnd | date:'shortTime')}}
              </b>
            </p>
          </rds-alert>
        </div>
        <div class="abstract-container pb-11" [class.mt-9]="userTimeZone === event.timeZone">
          <div class="abstract">
            <p class="abstract--title">Normal view</p>
            <div class="abstract--card">
              <rh-event-card-item
                [event]="event"
                [dateInEventTimeZone]="true"
                [disableAnimation]="true"
                [forceHoverState]="false"
              ></rh-event-card-item>
            </div>
          </div>
          <div class="abstract">
            <p class="abstract--title">Mouse over</p>
            <div class="abstract--card">
              <rh-event-card-item
                [event]="event"
                [dateInEventTimeZone]="true"
                [disableAnimation]="true"
                [forceHoverState]="true"
              ></rh-event-card-item>
            </div>
          </div>
        </div>
      </rds-tab>
      <rds-tab label="Event">
        <div *ngIf="userTimeZone !== event.timeZone" class="my-6">
          <rds-alert>
            <p>
              Date & Time on Event preview always considers original event time zone (<b>{{event.timeZone}}</b>)
            </p>
            <p>
              Date & Time of Event in your local time zone (<b>{{userTimeZone}}</b>) is: <b>{{zonedDate | date:'MMMM d, y'}} {{event.allDay ? 'All day' : (zonedStart | date:'shortTime') + ' - ' + (zonedEnd | date:'shortTime')}}
              </b>
            </p>
          </rds-alert>
        </div>
        <div class="event-container pb-11" [class.mobile]="contentMode === 'mobile'"
             [class.desktop]="contentMode === 'desktop'">
          <div class="event">
            <rh-event-preview [event]="event" [forceMobileView]="contentMode === 'mobile'"
                              [readOnly]="true"></rh-event-preview>
          </div>
        </div>
      </rds-tab>
    </rds-tabs>
    <div class="event-preview__heading--options">
      <rds-toggle
        *ngIf="showViewToggle"
        [(value)]="contentMode"
        [type]="'outlined'"
      >
        <rds-toggle-button
          value="desktop"
          [checked]="contentMode === 'desktop'"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.8595 17.57L19.9995 14.07V6C19.9995 4.9 19.0995 4 17.9995 4H5.99953C4.89953 4 3.99953 4.9 3.99953 6V14.07L2.13953 17.57C1.92953 18.03 1.95953 18.54 2.20953 18.97L2.25953 19.05C2.58953 19.63 3.27953 20 4.03953 20H19.9595C20.7195 20 21.4095 19.63 21.7395 19.05L21.7895 18.97C22.0395 18.54 22.0695 18.03 21.8595 17.57ZM5.99953 6H17.9995V14H5.99953V6ZM4.17953 18L5.23953 16H18.7595L19.8195 18H4.17953Z"/>
          </svg>
        </rds-toggle-button>
        <rds-toggle-button
          value="mobile"
          [checked]="contentMode === 'mobile'"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16 4V20H8V4H16ZM16 2H8C6.9 2 6 2.9 6 4V20C6 21.1 6.9 22 8 22H16C17.1 22 18 21.1 18 20V4C18 2.9 17.1 2 16 2Z"/>
            <path d="M10 3H14V4C14 4.55 13.55 5 13 5H11C10.45 5 10 4.55 10 4V3Z"/>
          </svg>
        </rds-toggle-button>
      </rds-toggle>
    </div>
  </div>
</div>
<div rds-dialog-actions-container align="end">
  <ng-container [ngSwitch]="context">
    <ng-container *ngSwitchCase="'Editor'">
      <button *ngIf="event.status === 1" rds-text-button (click)="gotoEventDetails(event.id)" size="m">
        Open link in new tab
        <rds-icon icon="launch"></rds-icon>
      </button>
      <button *ngIf="buttons?.canSaveEvent?.visible" [disabled]="buttons?.canSaveEvent?.disabled" rds-primary-button
              [rds-dialog-close]="'saveNewsAsDraft'" size="m">
        Save as draft
      </button>
    </ng-container>
    <ng-container *ngSwitchCase="'Table'">
      <button *ngIf="event.status === 1" rds-text-button (click)="gotoEventDetails(event.id)" size="m">
        Open link in new tab
        <rds-icon icon="launch"></rds-icon>
      </button>
      <button *ngIf="buttons?.editEvent?.visible" [disabled]="buttons?.editEvent?.disabled" rnbBackButtonSet
              [label]="backButton?.label" [routeBack]="backButton?.routeBack" [routeCurrent]="backButton?.routeCurrent"
              rds-primary-button [routerLink]="'/managing-events/'+event.id+'/edit'" [rds-dialog-close]="null" size="m">
        Edit event
      </button>
    </ng-container>
  </ng-container>
</div>
